/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcDesktopIcon32Regular = forwardRef('TechPcDesktopIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16 3a3 3 0 0 0-3 3v.5a1 1 0 1 0 2 0V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1h-5a1 1 0 1 0 0 2h5a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H16Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 13a4 4 0 0 1 4-4h13a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-3v2h1.5a1 1 0 1 1 0 2h-10a1 1 0 1 1 0-2H9v-2H6a4 4 0 0 1-4-4v-8Zm17 10H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Zm-5 4v-2h-3v2h3Z" })));
});
